"use client";

import { Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[0, 1, 2, 3, 4].map(i => <li key={i} data-index={i} className="h-4 w-24 bg-muted/30 animate-pulse rounded-md" />)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const shopLinks: Array<{
  label: string;
  to?: string;
  href?: string;
}> = [{
  label: "Pest Control",
  to: "/ServicesPage#pest-control"
}, {
  label: "Rodent Control",
  to: "/RodentControlPage"
}, {
  label: "Ant Control",
  to: "/AntControlPage"
}, {
  label: "Cockroach Control",
  to: "/CockroachControlPage"
}, {
  label: "Spider Control",
  to: "/SpiderControlPage"
}, {
  label: "Flea & Tick Control",
  to: "/FleaAndTickControlPage"
}, {
  label: "Mosquito Control",
  to: "/MosquitoControlPage"
}, {
  label: "Wasp & Stinging Insect Control",
  to: "/WaspStingingInsectControlPage"
}, {
  label: "Entry Point Treatments",
  to: "/ServicesPage#entry-point-treatments"
}, {
  label: "Commercial Pest Control",
  href: "/commercial-pest-control/"
}];
const atelierLinks = [{
  label: "Durham, NC",
  to: "/PestControlInDurhamNCPage"
}, {
  label: "Raleigh, NC",
  to: "/RaleighNCPestControlPage"
}, {
  label: "Cary, NC",
  to: "/CaryNCPestControlPage"
}, {
  label: "Chapel Hill, NC",
  to: "/PestControlInChapelHillNCPage"
}, {
  label: "Wake Forest, NC",
  to: "/PestControlInWakeForestNCPage"
}, {
  label: "Morrisville, NC",
  to: "/PestControlInMorrisvilleNCPage"
}, {
  label: "Hillsborough, NC",
  to: "/PestControlInHillsboroughNCPage"
}];
const serviceLinks = [{
  label: "Contact Us",
  to: "/ContactPage"
}, {
  label: "Call 919-896-1953",
  href: "tel:9198961953"
}, {
  label: "Our Blog",
  to: "/BlogPage"
}, {
  label: "Customer Portal",
  to: "/CustomerPortalPage"
}, {
  label: "Privacy Policy",
  to: "/PrivacyPolicyPage"
}, {
  label: "Terms of Service",
  to: "/TermsOfServicePage"
}];
export default function SiteFooter() {
  return <section data-section-id="231" id="site-footer" className="dark bg-background text-foreground relative overflow-hidden pt-30 pb-12 px-6 md:px-12">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-16 left-0 right-0 w-full overflow-hidden select-none">
        <div className="font-serif text-primary/5 leading-none whitespace-nowrap tracking-tighter text-center" style={{
        fontSize: "clamp(8rem, 22vw, 18rem)"
      }}>
          ATTIC TO BASEMENT
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {}
          <div className="space-y-5">
            <Link to="/HomePage" className="inline-block">
              <span className="font-default text-3xl font-bold tracking-tight text-foreground">
                ATTIC TO <span className="italic font-serif text-primary">BASEMENT</span>
              </span>
            </Link>
            <p className="font-default text-sm font-semibold tracking-wide text-primary">
              Protecting Homes. Protecting Families. It's Our Promise.
            </p>
            <p className="font-default text-sm leading-relaxed text-muted-foreground max-w-xs">
              Elite home sanctuary defense. Professional pest control services in the Triangle.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default text-xs font-bold uppercase tracking-[0.15em] text-primary mb-6">
              Services
            </h3>
            <ul className="space-y-3">
              {shopLinks.map((item, i) => <li key={item.label} data-index={i}>
                  {"href" in item && item.href ? <Link href={item.href} className="text-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
                      {item.label}
                    </Link> : <Link to={item.to!} className="text-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
                      {item.label}
                    </Link>}
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-xs font-bold uppercase tracking-[0.15em] text-primary mb-6">
              Service Areas
            </h3>
            <ul className="space-y-3">
              {atelierLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-xs font-bold uppercase tracking-[0.15em] text-primary mb-6">
              Support
            </h3>
            <MenuProvider menu_id="38">
              <FooterMenuConsumer />
            </MenuProvider>
            <ul className="space-y-3 mt-3">
              {serviceLinks.map((item, i) => <li key={item.label} data-index={i}>
                  {"href" in item && item.href ? <a href={item.href} className="text-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
                      {item.label}
                    </a> : <Link to={item.to} className="text-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
                      {item.label}
                    </Link>}
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <Separator className="my-12 bg-primary/20" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <div className="flex flex-col gap-2 order-2 md:order-1">
            <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground">
              &copy; 2025 ATTIC TO BASEMENT &middot; 919-896-1953
            </p>
            <Link to="mailto:attictobasement@gmail.com" className="font-mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground hover:text-primary transition-colors duration-300">
              attictobasement@gmail.com
            </Link>
          </div>

          {}
          <div className="flex items-center gap-6 order-1 md:order-2">
            <Link to="https://www.instagram.com/attictobasementpestcontrol1" newTab aria-label="Instagram" className="text-primary hover:text-foreground transition-colors duration-300">
              <Instagram strokeWidth={1.5} className="size-5" />
            </Link>
            <Link to="https://www.facebook.com/profile.php?id=61572871432190" newTab aria-label="Facebook" className="text-primary hover:text-foreground transition-colors duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="size-5" aria-hidden="true">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </Link>
            <Link to="https://www.linkedin.com/in/attic-to-basement-pest-control-482547353/" newTab aria-label="LinkedIn" className="text-primary hover:text-foreground transition-colors duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="size-5" aria-hidden="true">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                <rect width="4" height="12" x="2" y="9" />
                <circle cx="4" cy="4" r="2" />
              </svg>
            </Link>
          </div>

          {}
          <div className="order-3 flex items-center gap-2 text-[10px] uppercase tracking-[0.15em] text-muted-foreground font-mono">
            <span>North Carolina</span>
            <span className="text-primary/50">/</span>
            <span>Licensed & Insured</span>
          </div>
        </div>
      </div>
    </section>;
}